import { Injectable } from '@angular/core';

@Injectable()
export class Variables {
  mensajesnuevos: number=0;
}